document.addEventListener('DOMContentLoaded', function () {
    setTimeout(function () {
        const closeIcon = document.querySelector('.icon-close');
        const mobileMenu = document.querySelector('.wp-block-celebrate-suite-celebrate-modal-window');

        if (closeIcon) {
            closeIcon.addEventListener('click', function () {
                mobileMenu.classList.remove('show');
            });
        }
    }, 3000);
});
